<div class="container text-left">
  <mat-toolbar class="titulo">Detalhes do Ofício</mat-toolbar>
  <div class="container text-left">
    <mat-card class="card" *ngIf="ordem">
      <div class="row dados-titulo">
        <p class="col-md-12"><b>Número da Solicitação:</b> {{ getNroSolicitacao() }}</p>
        <p class="col-md-6"><b>Número do Processo:</b> {{ ordem.nroProcesso | mask: '0000000-00.0000.0.00.0000'}}</p>
        <p class="col-md-6"><b>Prazo de Atendimento:</b> {{ getDiasSla() }}</p>
      </div>
      <h3 class="subtitulo">Dados do Processo</h3>
      <div class="row dados-oficio">
        <p class="col-md-6"><b>Criado por:</b> {{ ordem.nomeServidor }}</p>
        <p class="col-md-6"><b>Tipo da Ordem:</b> {{ ordem.tpOrdemFormatado }}</p>
        <p class="col-md-6"><b>Foro:</b> {{ ordem.vara?.foro.nome }}</p>
        <p class="col-md-6"><b>Comarca:</b> {{ ordem.vara?.foro.praca.nome }}</p>
        <p class="col-md-6"><b>Vara:</b> {{ ordem.vara?.nome }}</p>
        <p class="col-md-6"><b>UF:</b> {{ ordem.vara?.foro.praca.uf }}</p>
        <p [class]="hasVlrAcao() ? 'col-md-6' : 'col-md-12'"><b>Status da Ordem:</b> {{ ordem.statusFormatado }}</p>
        <p class="col-md-6" *ngIf="hasVlrAcao()"><b>Valor:</b> {{ getformatedVlrAcao() }}</p>
        <p class="col-md-6"><b>Autor:</b> {{ ordem.autor ? ordem.autor : '--' }}</p>
        <p class="col-md-6"><b>Réu:</b> {{ ordem.reu ? ordem.reu : '--' }}</p>
        <p class="col-md-12" *ngIf="ordem.sistemaOrigem == 'SJ' && ordem.tpOrdem == 'HISTORICO'">
          <b>Período do Histórico:</b> {{ ordem.periodoHistorico }} ano(s)
        </p>
        <div class="col-md-12" *ngIf="hasMotivoCancelamento()">
          <h3 class="subtitulo">Motivo de cancelamento</h3>
          <p> {{ ordem.motivoCancelamento }} </p>
        </div>
        <div class="col-md-12" *ngIf="ordem.titulares && ordem.titulares.length">
          <h3 class="subtitulo">Titulares</h3>
          <div class="row" *ngFor="let titular of ordem.titulares">
            <p class="col-md-6"><b>Nome:</b> {{ titular.nome }}</p>
            <p class="col-md-6"><b>Documento:</b> {{ titular.nroDocumento | mask: isPessoaFisica(titular.nroDocumento) ? '000.000.000-00' : '00.000.000/0000-00' }}</p>
          </div>
        </div>
        <div class="col-md-12" *ngIf="ordem.credores && ordem.credores.length">
          <h3 class="subtitulo">Credores</h3>
          <div class="row" *ngFor="let credor of ordem.credores">
            <p class="col-md-12"><b>Nome:</b> {{ credor.nome }}</p>
            <p class="col-md-6"><b>Valor da dívida:</b> {{ credor.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</p>
            <p class="col-md-6"><b>Data da dívida:</b> {{ credor.dataDivida | date:'dd/MM/yyyy' }}</p>
            <p class="col-md-6" *ngIf="credor.documento"><b>Documento:</b> {{ credor.documento | mask: isPessoaFisica(credor.documento) ? '000.000.000-00' : '00.000.000/0000-00' }}</p>
            <p class="col-md-6" *ngIf="credor.numeroContrato"><b>Número do contrato:</b> {{ credor.numeroContrato }}</p>
            <br><br>
          </div>
        </div>
        <div class="col-md-12 arquivo-anexo" *ngIf="hasAnexo()">
          <p><b>Arquivo Anexado:</b> {{ nomeArquivo }}</p>
          <button matSuffix class="download-btn" (click)="downloadArquivo()" mat-raised-button>
            <img id="u653_img" src="../../../../assets/images/ordens_cadastradas/u653.png">
            Download
          </button>
        </div>
        <div class="col-md-12" *ngIf="hasDescricao()">
          <h3 class="subtitulo">Descrição</h3>
          <p> {{ ordem.decricaoOrdem }} </p>
        </div>
      </div>
    </mat-card>
    <div class="row ">
      <div class="col-md-10"></div>
      <div class="col-sm-2">
        <button mat-raised-button class="btn btn-azul btn-block" (click)="voltar()">
          Voltar
        </button>
      </div>
    </div>
  </div>
</div>
